
	import Component from 'vue-class-component'
	import moduleStore from './store/welfareCenter';
	import Vue from 'vue';
	import PageState from './store/state';
	import {getQueryString} from "@/utils/location";
	import { customCollectEvent } from '@/utils/collect';

	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class welfareCenterPage extends Vue implements IvuePage<PageState> {
		state = new PageState();
		self: Vue = this;
		contentData: any = [];
		urlList: any = ['/signIn', '/exchangeBean', '/chargeBean', '/memberDay', ''];
		isMinip: Boolean = false;
		flutterActivitySignIn: any = (<any>window).flutterActivitySignIn;
		vipDayObj: any ={};

		fakeObj ={
			benefitBackGroundImage: "https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-11-02-1348038964787814039.png",
			benefitImage: "https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-11-02-6655696573870932006.png",
			benefitName: "会员日",
			canReceive: 0,
			isShow: 1,
			startTime: 1705475270237,
			endTime: 1706080070237
		};
		
		timer:any = [null];


		created(moduleData: IinjectDatas) {
			this.state = <PageState>moduleData.state;
			this.benefitCenters();
		}

		beforeDestroy() {
			if(this.timer.length){
				for(let i = 0; i < this.timer.length; i++){
					clearTimeout(this.timer[i]);
				}
			}
		}

		mounted(moduleData: IinjectDatas) {
		}
		benefitCenters() {
			this.$http('benefitCenter', {}).then(res => {
				this.contentData = res.data
				// this.contentData.push(this.fakeObj)
				this.contentData.map((r, k) => {
					r.url = this.urlList[k];
					r.startTime && this.formatTime(r)
				})
				let benefitName = this.contentData.filter((r) => r.benefitName === '会员日')
				if(benefitName.length){
					this.getVipDayTime()
				}
                 //抖音不显示会员日 
                 let platform = getQueryString('platform');
                 if (platform) {
                   localStorage.setItem('platform', platform)
                 }
                 if(platform=='tt'){
                    this.contentData = this.contentData.filter((r) => r.benefitName !== '会员日')
                 }
				
			})
		}
		getVipDayTime(){
			this.$http('getCountdownTime').then(res => {
				// this.contentData.push(this.fakeObj)
				this.vipDayObj=res.data
				if(res.data.startTime && res.data.endTime){
					this.formatTime(this.vipDayObj)
				}
				
				
			})
			
		}
		formatTime(item){
			const { startTime, endTime } = item
			const now = Date.now();
			if (startTime) {
				if (startTime > now) {
					// 未开始
					this.$set(item, 'isStart', false)
					this.countdown(startTime,item);
				} else if (endTime && endTime < now) {
					// 已结束
					this.$set(item, 'isStart', false)
				} else {
					// 正在进行
					this.$set(item, 'isStart', true)
					this.countdown(endTime,item);
				}
			}
		}
		countdown(time,item) {
			const endDate:any = new Date(time).getTime()
			const now:any = new Date().getTime()
			const timeRemaining = endDate - now
			let timer = null
			if (timeRemaining <= 0) {
				console.log("倒计时结束");
				this.$set(item, 'timeStr', '本次活动已结束')
				clearTimeout(timer)
				return;
			}
			const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
			const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))<10?'0'+Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)):Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60))<10?'0'+Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)):Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)<10?'0'+Math.floor((timeRemaining % (1000 * 60)) / 1000):Math.floor((timeRemaining % (1000 * 60)) / 1000);
			const timeStr = days>0?`${days}天 ${hours}:${minutes}:${seconds}`:`${hours}:${minutes}:${seconds}`
			this.$set(item, 'timeStr', timeStr)
			// 使用setTimeout每秒更新倒计时
			timer = setTimeout(() => {
				this.countdown(time,item);
			}, 1000);
			this.timer.push(timer)
		}



		join(it) {
			// 埋点
			customCollectEvent("activity_name_click", {
				name: it.benefitName,
			});

			if (it.url == '') {
				this.$toast('开发中,敬请期待！');
			} else {
                //全部使用H5
				this.$router.push({path:`${it.url}?wwid=${getQueryString('wwid')}`})
			}
		}
	}